import script from "./BarBoys.vue?vue&type=script&setup=true&lang=js"
export * from "./BarBoys.vue?vue&type=script&setup=true&lang=js"

import "./BarBoys.vue?vue&type=style&index=0&id=792932ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792932ec"]])

export default __exports__